<so-modal-layout-ui
  [title]="'ws_sync_logs_modal_title' | translated : 'Logs de sincronización WS'"
  [icon]="'assets/img/mdi-file-document-outline.svg'"
  [iconColor]="'--color-icon'"
  [iconSize]="28"
  [showFooter]="false"
  [contentPadding]="'0'"
  (closed)="onClose()"
>
  <div class="ws-sync-logs-modal__body">
    <so-table-ui
      [tableData]="logs()"
      [tableHeaders]="tableHeaders"
      [isActionsEnabled]="false"
      [enableRowSelection]="false"
      [showSwitches]="false"
      [enablePagination]="false"
      [headerStyle]="'new'"
      [paddingBottomClass]="0"
      [borderRadius]="false"
    ></so-table-ui>
  </div>
</so-modal-layout-ui>
